import { Component } from '@angular/core';

@Component({
    selector: 'app-detail-faq-category',
    templateUrl: './detail-faq-category.component.html',
    styleUrls: ['./detail-faq-category.component.scss']
})
/** detail-faq-category component*/
export class DetailFaqCategoryComponent {
    /** detail-faq-category ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/faq-components/detail-faq-category/detail-faq-category.component.ts